/* @flow */
import cx from 'classnames';
import * as React from 'react';
import AppLayoutContentView from 'app/components/AppLayoutContentView';
import AppLayoutContentViewHeader from 'app/components/AppLayoutContentViewHeader';
import SettingsNavContainer from 'settings/containers/SettingsNavContainer';
import View from 'components/View';
import { withDocumentTitle } from 'lib/documentTitle';

import './styles/SettingsView.scss';

type Props = {
  children?: ?React.Element<any>,
  className?: ?string,
  goBack: () => void,
};

class SettingsView extends React.Component<Props> {
  renderHeader() {
    return (
      <AppLayoutContentViewHeader
        title="Back"
        onRequestPrevious={this.props.goBack}
        renderPreviousButton
      />
    );
  }

  render() {
    return (
      <AppLayoutContentView
        className={cx('SettingsView', this.props.className)}
        header={this.renderHeader()}
        sidebar={<SettingsNavContainer />}>
        <View className="SettingsView-content">
          <div className="SettingsView-content-view">{this.props.children}</div>
        </View>
      </AppLayoutContentView>
    );
  }
}

export default withDocumentTitle('Settings', SettingsView);
